import React, { ComponentProps, PropsWithChildren } from "react";
import { colors } from "@silversea-ssc/design-system-tokens";
import styles from "./FareInfographicsMosaic.module.scss";
import clsx from "clsx";
import { SectionContainer } from "../SectionContainer/SectionContainer";
import { BackgroundColor } from "../Backgrounds/background";

type Props = {
  topBackgroundColor?: BackgroundColor;
  bottomBackgroundColor?: BackgroundColor;
  oneCardHorizontalLayout?: boolean;
} & Omit<ComponentProps<typeof SectionContainer>, "backgroundColor">;

export const FareInfographicsMosaic: React.FC<PropsWithChildren<Props>> = ({
  topBackgroundColor,
  bottomBackgroundColor,
  oneCardHorizontalLayout = false,
  children,
  ...props
}) => {
  const topColor = colors[topBackgroundColor];
  const bottomColor = colors[bottomBackgroundColor];

  const colorStyle = {
    "--top-background-color": topColor,
    "--bottom-background-color": bottomColor
  } as React.CSSProperties;

  const numberOfCards = React.Children.count(children);

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return <div>{React.cloneElement(child)}</div>;
    }
  });

  return (
    <div
      className={styles.container}
      data-content-name="fares_mosaic"
      style={colorStyle}
    >
      <SectionContainer {...props} backgroundColor="transparent">
        <div
          className={clsx(styles.mosaic, {
            [styles.with1Card]: !oneCardHorizontalLayout && numberOfCards == 1,
            [styles.with1CardHorizontal]:
              oneCardHorizontalLayout && numberOfCards == 1,
            [styles.with2Cards]: numberOfCards == 2,
            [styles.withMoreCards]: numberOfCards > 2
          })}
        >
          {childrenWithProps}
        </div>
      </SectionContainer>
    </div>
  );
};
